export enum TransactionType {
  Send = 'send',
  Receive = 'receive',
}

export interface Contact {
  avatar: string
  name: string
  address: string
}

export interface ContactSection {
  kind: 'wallets' | 'contacts'
  contacts: Contact[]
}

export enum Chain {
  ICP = 'icp',
  BTC = 'btc',
  SOL = 'sol',
  ETH = 'eth',
  ODIN = 'odin',
  ARB = 'arb',
  BASE = 'base',
}

export type ChainOption = Chain | 'all'

export type NFT = ICNFT | BTCNFT

export interface ICNFT {
  standard: 'EXT' | 'ICRC7' | 'ICPUNKS' | 'DIP721'
  id?: string
  index: number
  url: string
  collection: string
}

export interface BTCNFT {
  id: string
  standard: 'ordinal'
  txId: string
  mintIndex: number
  metadata?: Record<string, string>
  number: number
  address: string
  contentType?: string
  contentLength: number
  value: string
  satOrdinal: string
  satRarity: string
  timestamp: number
  genesisTimestamp: number
  url: string
  collection: string
}

export interface NFTCollection {
  canisterId: string
  name: string
  icon?: string
  description?: string
  nfts: NFT[]
  chain: Chain
}

export interface SNS {
  symbol: string
  indexCanisterId: string
  rootCanisterId?: string
  ledgerCanisterId: string
  governanceCanisterId?: string
}

export interface TokenDetails {
  name: string
  symbol: string
  decimals: number
  fee: number
  logo: string
  principalId: string
  standard: string
}

export interface TokenPrice {
  symbol: string
  price: number
}

export interface Network {
  id: string
  name: string
  hostUrl: string
}

export type AnalyticsProvider = 'ledgerscanner' | 'phantom' | 'odin'
export type PriceProvider = 'icpswap' | 'coingecko' | 'odin'

export interface AnalyticsDetails {
  analyticsProvider?: AnalyticsProvider
  analyticsId?: string
  priceProvider?: PriceProvider
  priceId?: string
}

export interface PlugTokenGroup {
  id: string
  name: string
  symbol: string
  logoUrl: string
  analyticsDetails: AnalyticsDetails
}

export interface PlugToken {
  id: string
  chain: Chain
  logo: string
  name: string
  description?: string
  address?: string
  standard: string
  symbol: string
  decimals: number
  fee?: number
  tags: string[]
  groupId?: string
  analyticsDetails: AnalyticsDetails
}

export interface ICToken extends PlugToken {
  chain: Chain.ICP
  address: string
}

export interface OdinToken extends PlugToken {
  chain: Chain.ODIN
  fee: number
}
